import Title from './Title.vue';

export default Title;
